module.exports = __webpack_public_path__ + "img/monitor-mobile.f472f097.svg";